import { createSelector } from '@ngrx/store';
import { IProfessionState } from './profession.reducer';
const professionStore = (state: any) => state.profession as IProfessionState;
export const selectProfessionLista = createSelector(
  professionStore,
  (state) => state.lista
);

export const selectProfessionLoading = createSelector(
  professionStore,
  (state) => state.isLoading
);
